export type EngagementClock = { seconds: number; lastTick: number; lastActivity: number }
// Monotonic browser clock: cap stalled intervals and exclude idle/background time.
export function advanceEngagement(clock: EngagementClock, now: number, visible: boolean, focused: boolean): EngagementClock {
  const elapsed = Math.max(0, Math.min(5000, now - clock.lastTick))
  const activeUntil = clock.lastActivity + 60000
  const activeMs = Math.max(0, Math.min(now, activeUntil) - Math.max(clock.lastTick, now - elapsed))
  return { ...clock, lastTick: now, seconds: Math.min(3600, clock.seconds + (visible && focused ? activeMs / 1000 : 0)) }
}
export function articleScrollDepth(top: number, height: number, viewportHeight: number): number {
  return Math.max(0, Math.min(100, Math.floor((viewportHeight - top) / Math.max(1, height) * 100)))
}
